export const SET_PAYMENT_INFO_SUCCESS = 'SET_PAYMENT_INFO_SUCCESS'
export const CLEAR_ALL_PAYMENT_INFO_SUCCESS = 'CLEAR_ALL_PAYMENT_INFO_SUCCESS'
export const SET_BUYERS_PORTAL_MAIL_SUCCESS = 'SET_BUYERS_PORTAL_MAIL_SUCCESS'